import { cachedRequest } from '../area-reports/requests'
import {writable} from "svelte/store";

function pointQueryUrl (report, layerName, layerId) {
  const url = new URL(ENVIRONMENT.baseURL());
  // /services/point_query/json?epsg=2193&latitude=1752800&layers=lri_arable_suitability&longitude=5617920
  url.pathname = '/services/point_query/json';

  const subject = report.subject;

  url.searchParams.set('epsg', subject.srid || 2193);
  const [latitude, longitude] = subject.featureCollection.features[0].geometry.coordinates;

  url.searchParams.set('latitude', latitude);
  url.searchParams.set('longitude', longitude);
  url.searchParams.set('layers', layerName);

  return url.toString();
}

export function pointQuery (report, layerName, layerId) {
  if (report) {
    const url = pointQueryUrl(report, layerName, layerId);
    return cachedRequest(url);
  }

  return {
    request: Promise.reject(),
    retryStore: writable(undefined)
  };
}
